exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".result-column-head-text-form-element{color:#0c5a81;cursor:pointer}.result-column-head-text-form-element:hover{text-decoration:underline}.result-column-head-text-form-element-selected{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/search/FormElements/ResultColumnHeadTextFormElement/ResultColumnHeadTextFormElement.less
// module id = 1630
// module chunks = 0